import moment from "moment";
import "moment/locale/pt-br";

export const formatarCPF = (cpf) => {
  if (cpf) {
    return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }
};

export const formataDataResumida = (dataString) => {
  if (dataString && moment(dataString).isValid()) {
    return moment(dataString).format("DD MMM HH:mm");
  }
};

export const formataDataCompleta = (dataString) => {
  if (dataString && moment(dataString).isValid()) {
    let dataCompleta = moment(dataString).format(
      "dddd[,] DD [de] MMMM [de] YYYY"
    );

    return dataCompleta.charAt(0).toUpperCase() + dataCompleta.slice(1);
  }
};

export const formataDataBarra = (dataString) => {
  if (dataString && moment(dataString).isValid()) {
    return moment(dataString).format("DD/MM/YYYY HH:mm");
  }
};

export const formataDataBarraSemHora = (dataString) => {
  if (dataString && moment(dataString).isValid()) {
    return moment(dataString).format("DD/MM/YYYY");
  }
};

export const formataHora = (dataString) => {
  if (dataString && moment(dataString).isValid()) {
    return moment(dataString).format("HH:mm");
  }
};
